// Last loaded assortment per supplier scope, kept for this page session only. A return to
// Sales Trends renders the known segment set at once while the fresh request revalidates
// it, so the segment row does not start from the full placeholder set and shrink under
// the user (MP-OS-188). Kept import-free so the test setup can clear it without loading
// modules that test files mock.
const lastByScope = new Map<string, unknown>()

export function cachedAssortment<T>(scope: string): T | undefined {
  return lastByScope.get(scope) as T | undefined
}

export function rememberAssortment(scope: string, data: unknown): void {
  lastByScope.set(scope, data)
}

export function clearAssortmentCache(): void {
  lastByScope.clear()
}
